export default "__VITE_ASSET__Cg1IRM4S__"